import { useEffect } from "react";

/**
 * Sets this page's <title> and meta description while it's mounted, then
 * restores whatever was there before. Without this, every route shares
 * index.html's single static tags (backlog LAUNCH-28) — no SSR here, so
 * this only affects the client-rendered document, but Google's crawler
 * does execute JS and reads the final rendered title/meta, which is what
 * this app's real crawlable surface (a handful of public routes) needs.
 */
export function useDocumentTitle(title: string, description?: string): void {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const meta = description ? document.querySelector('meta[name="description"]') : null;
    const prevDescription = meta?.getAttribute("content") ?? null;
    if (meta && description) meta.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (meta && prevDescription !== null) meta.setAttribute("content", prevDescription);
    };
  }, [title, description]);
}
